/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orgs_EmptyInputs */

const th_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีองค์กร`)
};

const en_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organisations yet.`)
};

const ja_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`団体はまだありません。`)
};

const zh_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无组织。`)
};

const es_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay organizaciones.`)
};

const pt_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma organização ainda.`)
};

const id_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada organisasi.`)
};

const fr_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune organisation pour l’instant.`)
};

const tl_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang organisasyon.`)
};

const vi_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có tổ chức nào.`)
};

const ko_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 조직이 없습니다.`)
};

const de_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Organisationen.`)
};

const ru_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организаций пока нет.`)
};

const tr_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz kuruluş yok.`)
};

const it_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna organizzazione.`)
};

const pl_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze organizacji.`)
};

const uk_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Організацій поки немає.`)
};

const hi_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई संगठन नहीं।`)
};

const ar_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مؤسسات بعد.`)
};

const ms_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada organisasi.`)
};

const bn_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও সংস্থা নেই।`)
};

const zh_tw2_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無組織。`)
};

const zh_hk2_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無組織。`)
};

const ur_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی ادارہ نہیں۔`)
};

const fa_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز سازمانی نیست.`)
};

const sw_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mashirika bado.`)
};

const nl_orgs_empty = /** @type {(inputs: Orgs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen organisaties.`)
};

/**
* | output |
* | --- |
* | "No organisations yet." |
*
* @param {Orgs_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const orgs_empty = /** @type {((inputs?: Orgs_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orgs_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_orgs_empty(inputs)
	if (locale === "ja") return ja_orgs_empty(inputs)
	if (locale === "zh") return zh_orgs_empty(inputs)
	if (locale === "es") return es_orgs_empty(inputs)
	if (locale === "pt") return pt_orgs_empty(inputs)
	if (locale === "id") return id_orgs_empty(inputs)
	if (locale === "fr") return fr_orgs_empty(inputs)
	if (locale === "tl") return tl_orgs_empty(inputs)
	if (locale === "vi") return vi_orgs_empty(inputs)
	if (locale === "ko") return ko_orgs_empty(inputs)
	if (locale === "de") return de_orgs_empty(inputs)
	if (locale === "ru") return ru_orgs_empty(inputs)
	if (locale === "tr") return tr_orgs_empty(inputs)
	if (locale === "it") return it_orgs_empty(inputs)
	if (locale === "pl") return pl_orgs_empty(inputs)
	if (locale === "uk") return uk_orgs_empty(inputs)
	if (locale === "hi") return hi_orgs_empty(inputs)
	if (locale === "ar") return ar_orgs_empty(inputs)
	if (locale === "ms") return ms_orgs_empty(inputs)
	if (locale === "bn") return bn_orgs_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_orgs_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_orgs_empty(inputs)
	if (locale === "ur") return ur_orgs_empty(inputs)
	if (locale === "fa") return fa_orgs_empty(inputs)
	if (locale === "sw") return sw_orgs_empty(inputs)
	if (locale === "nl") return nl_orgs_empty(inputs)
	return en_orgs_empty(inputs)
});